import React, { lazy, Suspense } from 'react';
import 'react-chat-elements/dist/main.css';
import { ChatProvider, useChatContext } from './context/ChatContext';
import ErrorBoundary from './components/ErrorBoundary';
import ChatHeader from './components/ChatHeader';
import MessageList from './components/MessageList';
import MessageInput from './components/MessageInput';
import { downloadConversation } from './utils/downloadUtils';
import { usePerformance } from './hooks/usePerformance';
import './styles/App.css';
import './styles/accessibility.css';

const DownloadDialog = lazy(() => import('./components/DownloadDialog'));

function AppContent() {
  const { messages, showDownloadDialog, dispatch } = useChatContext();
  usePerformance('AppContent');

  const startNewChat = () => {
    dispatch({ type: 'RESET_CHAT' });
  };

  const handleDownloadClick = () => {
    dispatch({ type: 'SET_SHOW_DOWNLOAD_DIALOG', payload: true });
  };

  const handleDownloadClose = () => {
    dispatch({ type: 'SET_SHOW_DOWNLOAD_DIALOG', payload: false });
  };

  const handleDownload = async (format) => {
    dispatch({ type: 'SET_IS_DOWNLOADING', payload: true });
    try {
      await downloadConversation(messages, format);
    } catch {
      alert("Download failed. Try again.");
    } finally {
      dispatch({ type: 'SET_IS_DOWNLOADING', payload: false });
    }
  };

  return (
    <div className="chat-container">
      <ChatHeader onNewChat={startNewChat} onDownloadClick={handleDownloadClick} />
      <MessageList />
      <MessageInput />
      
      <Suspense fallback={<div>Loading...</div>}>
        <DownloadDialog
          isOpen={showDownloadDialog}
          onClose={handleDownloadClose}
          onDownload={handleDownload}
          messages={messages}
        />
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ChatProvider>
        <AppContent />
      </ChatProvider>
    </ErrorBoundary>
  );
}

export default App;